<template>
  <div id="start">
    <Info />
    <div class="textonslide" style="z-index:20">
      Sai Prachodhan Devulapalli
      <div id="span"></div>
      I'm
      <vue-typer
        :text="text"
        erase-style="backspace"
        :shuffle="false"
        initial-action="typing"
        :pre-type-delay="70"
        :type-delay="70"
        :pre-erase-delay="2000"
        :erase-delay="250"
      ></vue-typer>
    </div>
  </div>
</template>

<script>
import Info from "./Info.vue";
export default {
  components: { Info },
  name: "Firstslide",
  data() {
    return {
      text: [
        "Web developer",
        "Student",
        "Programmer",
        "Freelancer",
        "Web designer",
      ],
    };
  },
};
</script>
<style>
.vue-typer {
  font-family: Copperplate, "Copperplate Gothic Light", fantasy, "Dongle";
  font-weight: 700;
  font-size: 3rem;
  text-transform: uppercase;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .vue-typer {
    font-family: Copperplate, "Copperplate Gothic Light", fantasy, "Dongle",
      "Roboto";
    font-weight: 700;
    font-size: 1.9rem;
  }
}
@media screen and (max-width: 280px) {
  .vue-typer {
    font-family: Copperplate, "Copperplate Gothiac Light", fantasy, "Dongle",
      "Roboto";
    font-weight: 700;
    font-size: 1.5rem;
  }
}
.vue-typer .custom.char.typed {
  color: #009688;
  color: orange;
  padding-bottom: 5px;
}
.vue-typer .custom.caret {
  width: 3px;
  background-color: white;
}
</style>
<style scoped>
#span {
  width: 25vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  border-bottom: 4px solid skyblue;
}
#start {
  position: absolute;
  left: 22vw;
  width: 78vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
}
.textonslide {
  color: white;
  position: absolute;
  top: 35vh;
  width: 65vw;
  left: 5vw;
  font-size: 3.2rem;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  #start {
    height: 60vh;
    overflow-x: hidden;
    overflow: hidden;
    position: absolute;
    left: 0;
    width: 100vw;
  }
  .textonslide {
    color: white;
    position: absolute;
    top: 18vh;
    width: 90vw;
    left: 10vw;
    font-size: 1.9rem;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
  }
}
@media screen and (max-width: 280px) {
  .textonslide {
    color: white;
    position: absolute;
    top: 15vh;
    width: 90vw;
    left: 10vw;
    font-size: 1.9rem;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
  }
}
@media screen and (max-height: 2000px) and (min-height: 1300px) and (min-width: 1000px) {
  #start {
    height: 60vh;
    overflow-x: hidden;
    position: absolute;
    left: 0;
    overflow: hidden;
    width: 100vw;
  }
  .textonslide {
    color: white;
    position: absolute;
    top: 20vh;
    width: 90vw;
    left: 10vw;
    font-size: 3.2rem;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
  }
}
</style>
